// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as privateRouteRouteImport } from './routes/(private)/route'
import { Route as OnboardingRouteRouteImport } from './routes/onboarding/route'
import { Route as privateBookingRouteRouteImport } from './routes/(private)/booking/route'
import { Route as privateFinancesRouteRouteImport } from './routes/(private)/finances/route'
import { Route as privateLibraryRouteRouteImport } from './routes/(private)/library/route'
import { Route as privateOfferRouteRouteImport } from './routes/(private)/offer/route'
import { Route as privateTraineesRouteRouteImport } from './routes/(private)/trainees/route'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as ConsentIndexRouteImport } from './routes/consent/index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as privateBillingIndexRouteImport } from './routes/(private)/billing/index'
import { Route as privateBookingIndexRouteImport } from './routes/(private)/booking/index'
import { Route as privateBookingTrainingsRouteRouteImport } from './routes/(private)/booking/trainings/route'
import { Route as privateClientsSplatRouteImport } from './routes/(private)/clients/$'
import { Route as privateExercisesIndexRouteImport } from './routes/(private)/exercises/index'
import { Route as privateFinancesIndexRouteImport } from './routes/(private)/finances/index'
import { Route as privateLibraryIndexRouteImport } from './routes/(private)/library/index'
import { Route as privateLibraryExercisesRouteImport } from './routes/(private)/library/exercises'
import { Route as privateLibraryPlansRouteRouteImport } from './routes/(private)/library/plans/route'
import { Route as privateLibraryWorkoutsRouteRouteImport } from './routes/(private)/library/workouts/route'
import { Route as privateNotificationsIndexRouteImport } from './routes/(private)/notifications/index'
import { Route as privateOfferIndexRouteImport } from './routes/(private)/offer/index'
import { Route as privatePaymentsIndexRouteImport } from './routes/(private)/payments/index'
import { Route as privateSettingsIndexRouteImport } from './routes/(private)/settings/index'
import { Route as privateShopIndexRouteImport } from './routes/(private)/shop/index'
import { Route as privateTodayIndexRouteImport } from './routes/(private)/today/index'
import { Route as privateTraineesIndexRouteImport } from './routes/(private)/trainees/index'
import { Route as privateTraineesClientIdRouteRouteImport } from './routes/(private)/trainees/$clientId/route'
import { Route as publicBlogIndexRouteImport } from './routes/(public)/blog/index'
import { Route as publicCallbackIndexRouteImport } from './routes/(public)/callback/index'
import { Route as publicConsumerHealthDataIndexRouteImport } from './routes/(public)/consumer-health-data/index'
import { Route as publicContactIndexRouteImport } from './routes/(public)/contact/index'
import { Route as publicContentPolicyIndexRouteImport } from './routes/(public)/content-policy/index'
import { Route as publicCookiesIndexRouteImport } from './routes/(public)/cookies/index'
import { Route as publicDpaIndexRouteImport } from './routes/(public)/dpa/index'
import { Route as publicFeaturesIndexRouteImport } from './routes/(public)/features/index'
import { Route as publicHelpIndexRouteImport } from './routes/(public)/help/index'
import { Route as publicHelpSlugRouteImport } from './routes/(public)/help/$slug'
import { Route as publicHowItWorksIndexRouteImport } from './routes/(public)/how-it-works/index'
import { Route as publicLegalIndexRouteImport } from './routes/(public)/legal/index'
import { Route as publicLoginIndexRouteImport } from './routes/(public)/login/index'
import { Route as publicLogoutIndexRouteImport } from './routes/(public)/logout/index'
import { Route as publicNewPasswordIndexRouteImport } from './routes/(public)/new-password/index'
import { Route as publicPricingIndexRouteImport } from './routes/(public)/pricing/index'
import { Route as publicPrivacyIndexRouteImport } from './routes/(public)/privacy/index'
import { Route as publicSignupIndexRouteImport } from './routes/(public)/signup/index'
import { Route as publicTermsIndexRouteImport } from './routes/(public)/terms/index'
import { Route as publicWhoItsForIndexRouteImport } from './routes/(public)/who-its-for/index'
import { Route as privateBookingAvailabilityIndexRouteImport } from './routes/(private)/booking/availability/index'
import { Route as privateBookingEventsIndexRouteImport } from './routes/(private)/booking/events/index'
import { Route as privateBookingGymIndexRouteImport } from './routes/(private)/booking/gym/index'
import { Route as privateBookingRequestsIndexRouteImport } from './routes/(private)/booking/requests/index'
import { Route as privateBookingSetupIndexRouteImport } from './routes/(private)/booking/setup/index'
import { Route as privateBookingTrainingsIndexRouteImport } from './routes/(private)/booking/trainings/index'
import { Route as privateBookingTrainingsTrainingIdRouteImport } from './routes/(private)/booking/trainings/$trainingId'
import { Route as privateFinancesInvoicesIndexRouteImport } from './routes/(private)/finances/invoices/index'
import { Route as privateFinancesOffersIndexRouteImport } from './routes/(private)/finances/offers/index'
import { Route as privateFinancesPaymentsIndexRouteImport } from './routes/(private)/finances/payments/index'
import { Route as privateFinancesSettingsIndexRouteImport } from './routes/(private)/finances/settings/index'
import { Route as privateFinancesSubscriptionsIndexRouteImport } from './routes/(private)/finances/subscriptions/index'
import { Route as privateLibraryPlansIndexRouteImport } from './routes/(private)/library/plans/index'
import { Route as privateLibraryPlansPlanIdRouteImport } from './routes/(private)/library/plans/$planId'
import { Route as privateLibraryWorkoutsIndexRouteImport } from './routes/(private)/library/workouts/index'
import { Route as privateLibraryWorkoutsPlanIdRouteImport } from './routes/(private)/library/workouts/$planId'
import { Route as privateOfferArchiveIndexRouteImport } from './routes/(private)/offer/archive/index'
import { Route as privateOfferOrdersIndexRouteImport } from './routes/(private)/offer/orders/index'
import { Route as privateOfferPacksIndexRouteImport } from './routes/(private)/offer/packs/index'
import { Route as privateOfferProductsIndexRouteImport } from './routes/(private)/offer/products/index'
import { Route as privateShopProductIdIndexRouteImport } from './routes/(private)/shop/$productId/index'
import { Route as privateShopOrdersIndexRouteImport } from './routes/(private)/shop/orders/index'
import { Route as privateTraineesClientIdIndexRouteImport } from './routes/(private)/trainees/$clientId/index'
import { Route as privateTraineesClientIdBillingRouteImport } from './routes/(private)/trainees/$clientId/billing'
import { Route as privateTraineesClientIdDietRouteImport } from './routes/(private)/trainees/$clientId/diet'
import { Route as privateTraineesClientIdDietPlansRouteRouteImport } from './routes/(private)/trainees/$clientId/diet-plans/route'
import { Route as privateTraineesClientIdPacksRouteImport } from './routes/(private)/trainees/$clientId/packs'
import { Route as privateTraineesClientIdPlansRouteImport } from './routes/(private)/trainees/$clientId/plans'
import { Route as privateTraineesClientIdProgressRouteRouteImport } from './routes/(private)/trainees/$clientId/progress/route'
import { Route as privateTraineesClientIdRecoveryRouteImport } from './routes/(private)/trainees/$clientId/recovery'
import { Route as privateTraineesClientIdTrainingPlansRouteRouteImport } from './routes/(private)/trainees/$clientId/training-plans/route'
import { Route as publicBlogSlugIndexRouteImport } from './routes/(public)/blog/$slug/index'
import { Route as publicBlogAuthorAuthorSlugRouteImport } from './routes/(public)/blog/author/$authorSlug'
import { Route as publicBlogCategoryCategorySlugRouteImport } from './routes/(public)/blog/category/$categorySlug'
import { Route as privateOfferProductsProductIdIndexRouteImport } from './routes/(private)/offer/products/$productId/index'
import { Route as privateTraineesClientIdDietPlansIndexRouteImport } from './routes/(private)/trainees/$clientId/diet-plans/index'
import { Route as privateTraineesClientIdDietPlansPlanIdRouteImport } from './routes/(private)/trainees/$clientId/diet-plans/$planId'
import { Route as privateTraineesClientIdProgressIndexRouteImport } from './routes/(private)/trainees/$clientId/progress/index'
import { Route as privateTraineesClientIdProgressMetricIdRouteImport } from './routes/(private)/trainees/$clientId/progress/$metricId'
import { Route as privateTraineesClientIdTrainingPlansIndexRouteImport } from './routes/(private)/trainees/$clientId/training-plans/index'
import { Route as privateTraineesClientIdTrainingPlansPlanIdRouteImport } from './routes/(private)/trainees/$clientId/training-plans/$planId'

const privateRouteRoute = privateRouteRouteImport.update({
            id: '/(private)',getParentRoute: () => rootRouteImport
          })
const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const privateBookingRouteRoute = privateBookingRouteRouteImport.update({
            id: '/booking',path: '/booking',getParentRoute: () => privateRouteRoute
          })
const privateFinancesRouteRoute = privateFinancesRouteRouteImport.update({
            id: '/finances',path: '/finances',getParentRoute: () => privateRouteRoute
          })
const privateLibraryRouteRoute = privateLibraryRouteRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => privateRouteRoute
          })
const privateOfferRouteRoute = privateOfferRouteRouteImport.update({
            id: '/offer',path: '/offer',getParentRoute: () => privateRouteRoute
          })
const privateTraineesRouteRoute = privateTraineesRouteRouteImport.update({
            id: '/trainees',path: '/trainees',getParentRoute: () => privateRouteRoute
          })
const publicIndexRoute = publicIndexRouteImport.update({
            id: '/(public)/',path: '/',getParentRoute: () => rootRouteImport
          })
const ConsentIndexRoute = ConsentIndexRouteImport.update({
            id: '/consent/',path: '/consent/',getParentRoute: () => rootRouteImport
          })
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OnboardingRouteRoute
          })
const privateBillingIndexRoute = privateBillingIndexRouteImport.update({
            id: '/billing/',path: '/billing/',getParentRoute: () => privateRouteRoute
          })
const privateBookingIndexRoute = privateBookingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBookingRouteRoute
          })
const privateBookingTrainingsRouteRoute = privateBookingTrainingsRouteRouteImport.update({
            id: '/trainings',path: '/trainings',getParentRoute: () => privateBookingRouteRoute
          })
const privateClientsSplatRoute = privateClientsSplatRouteImport.update({
            id: '/clients/$',path: '/clients/$',getParentRoute: () => privateRouteRoute
          })
const privateExercisesIndexRoute = privateExercisesIndexRouteImport.update({
            id: '/exercises/',path: '/exercises/',getParentRoute: () => privateRouteRoute
          })
const privateFinancesIndexRoute = privateFinancesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateFinancesRouteRoute
          })
const privateLibraryIndexRoute = privateLibraryIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateLibraryRouteRoute
          })
const privateLibraryExercisesRoute = privateLibraryExercisesRouteImport.update({
            id: '/exercises',path: '/exercises',getParentRoute: () => privateLibraryRouteRoute
          })
const privateLibraryPlansRouteRoute = privateLibraryPlansRouteRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => privateLibraryRouteRoute
          })
const privateLibraryWorkoutsRouteRoute = privateLibraryWorkoutsRouteRouteImport.update({
            id: '/workouts',path: '/workouts',getParentRoute: () => privateLibraryRouteRoute
          })
const privateNotificationsIndexRoute = privateNotificationsIndexRouteImport.update({
            id: '/notifications/',path: '/notifications/',getParentRoute: () => privateRouteRoute
          })
const privateOfferIndexRoute = privateOfferIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateOfferRouteRoute
          })
const privatePaymentsIndexRoute = privatePaymentsIndexRouteImport.update({
            id: '/payments/',path: '/payments/',getParentRoute: () => privateRouteRoute
          })
const privateSettingsIndexRoute = privateSettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => privateRouteRoute
          })
const privateShopIndexRoute = privateShopIndexRouteImport.update({
            id: '/shop/',path: '/shop/',getParentRoute: () => privateRouteRoute
          })
const privateTodayIndexRoute = privateTodayIndexRouteImport.update({
            id: '/today/',path: '/today/',getParentRoute: () => privateRouteRoute
          })
const privateTraineesIndexRoute = privateTraineesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateTraineesRouteRoute
          })
const privateTraineesClientIdRouteRoute = privateTraineesClientIdRouteRouteImport.update({
            id: '/$clientId',path: '/$clientId',getParentRoute: () => privateTraineesRouteRoute
          })
const publicBlogIndexRoute = publicBlogIndexRouteImport.update({
            id: '/(public)/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const publicCallbackIndexRoute = publicCallbackIndexRouteImport.update({
            id: '/(public)/callback/',path: '/callback/',getParentRoute: () => rootRouteImport
          })
const publicConsumerHealthDataIndexRoute = publicConsumerHealthDataIndexRouteImport.update({
            id: '/(public)/consumer-health-data/',path: '/consumer-health-data/',getParentRoute: () => rootRouteImport
          })
const publicContactIndexRoute = publicContactIndexRouteImport.update({
            id: '/(public)/contact/',path: '/contact/',getParentRoute: () => rootRouteImport
          })
const publicContentPolicyIndexRoute = publicContentPolicyIndexRouteImport.update({
            id: '/(public)/content-policy/',path: '/content-policy/',getParentRoute: () => rootRouteImport
          })
const publicCookiesIndexRoute = publicCookiesIndexRouteImport.update({
            id: '/(public)/cookies/',path: '/cookies/',getParentRoute: () => rootRouteImport
          })
const publicDpaIndexRoute = publicDpaIndexRouteImport.update({
            id: '/(public)/dpa/',path: '/dpa/',getParentRoute: () => rootRouteImport
          })
const publicFeaturesIndexRoute = publicFeaturesIndexRouteImport.update({
            id: '/(public)/features/',path: '/features/',getParentRoute: () => rootRouteImport
          })
const publicHelpIndexRoute = publicHelpIndexRouteImport.update({
            id: '/(public)/help/',path: '/help/',getParentRoute: () => rootRouteImport
          })
const publicHelpSlugRoute = publicHelpSlugRouteImport.update({
            id: '/(public)/help/$slug',path: '/help/$slug',getParentRoute: () => rootRouteImport
          })
const publicHowItWorksIndexRoute = publicHowItWorksIndexRouteImport.update({
            id: '/(public)/how-it-works/',path: '/how-it-works/',getParentRoute: () => rootRouteImport
          })
const publicLegalIndexRoute = publicLegalIndexRouteImport.update({
            id: '/(public)/legal/',path: '/legal/',getParentRoute: () => rootRouteImport
          })
const publicLoginIndexRoute = publicLoginIndexRouteImport.update({
            id: '/(public)/login/',path: '/login/',getParentRoute: () => rootRouteImport
          })
const publicLogoutIndexRoute = publicLogoutIndexRouteImport.update({
            id: '/(public)/logout/',path: '/logout/',getParentRoute: () => rootRouteImport
          })
const publicNewPasswordIndexRoute = publicNewPasswordIndexRouteImport.update({
            id: '/(public)/new-password/',path: '/new-password/',getParentRoute: () => rootRouteImport
          })
const publicPricingIndexRoute = publicPricingIndexRouteImport.update({
            id: '/(public)/pricing/',path: '/pricing/',getParentRoute: () => rootRouteImport
          })
const publicPrivacyIndexRoute = publicPrivacyIndexRouteImport.update({
            id: '/(public)/privacy/',path: '/privacy/',getParentRoute: () => rootRouteImport
          })
const publicSignupIndexRoute = publicSignupIndexRouteImport.update({
            id: '/(public)/signup/',path: '/signup/',getParentRoute: () => rootRouteImport
          })
const publicTermsIndexRoute = publicTermsIndexRouteImport.update({
            id: '/(public)/terms/',path: '/terms/',getParentRoute: () => rootRouteImport
          })
const publicWhoItsForIndexRoute = publicWhoItsForIndexRouteImport.update({
            id: '/(public)/who-its-for/',path: '/who-its-for/',getParentRoute: () => rootRouteImport
          })
const privateBookingAvailabilityIndexRoute = privateBookingAvailabilityIndexRouteImport.update({
            id: '/availability/',path: '/availability/',getParentRoute: () => privateBookingRouteRoute
          })
const privateBookingEventsIndexRoute = privateBookingEventsIndexRouteImport.update({
            id: '/events/',path: '/events/',getParentRoute: () => privateBookingRouteRoute
          })
const privateBookingGymIndexRoute = privateBookingGymIndexRouteImport.update({
            id: '/gym/',path: '/gym/',getParentRoute: () => privateBookingRouteRoute
          })
const privateBookingRequestsIndexRoute = privateBookingRequestsIndexRouteImport.update({
            id: '/requests/',path: '/requests/',getParentRoute: () => privateBookingRouteRoute
          })
const privateBookingSetupIndexRoute = privateBookingSetupIndexRouteImport.update({
            id: '/setup/',path: '/setup/',getParentRoute: () => privateBookingRouteRoute
          })
const privateBookingTrainingsIndexRoute = privateBookingTrainingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBookingTrainingsRouteRoute
          })
const privateBookingTrainingsTrainingIdRoute = privateBookingTrainingsTrainingIdRouteImport.update({
            id: '/$trainingId',path: '/$trainingId',getParentRoute: () => privateBookingTrainingsRouteRoute
          })
const privateFinancesInvoicesIndexRoute = privateFinancesInvoicesIndexRouteImport.update({
            id: '/invoices/',path: '/invoices/',getParentRoute: () => privateFinancesRouteRoute
          })
const privateFinancesOffersIndexRoute = privateFinancesOffersIndexRouteImport.update({
            id: '/offers/',path: '/offers/',getParentRoute: () => privateFinancesRouteRoute
          })
const privateFinancesPaymentsIndexRoute = privateFinancesPaymentsIndexRouteImport.update({
            id: '/payments/',path: '/payments/',getParentRoute: () => privateFinancesRouteRoute
          })
const privateFinancesSettingsIndexRoute = privateFinancesSettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => privateFinancesRouteRoute
          })
const privateFinancesSubscriptionsIndexRoute = privateFinancesSubscriptionsIndexRouteImport.update({
            id: '/subscriptions/',path: '/subscriptions/',getParentRoute: () => privateFinancesRouteRoute
          })
const privateLibraryPlansIndexRoute = privateLibraryPlansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateLibraryPlansRouteRoute
          })
const privateLibraryPlansPlanIdRoute = privateLibraryPlansPlanIdRouteImport.update({
            id: '/$planId',path: '/$planId',getParentRoute: () => privateLibraryPlansRouteRoute
          })
const privateLibraryWorkoutsIndexRoute = privateLibraryWorkoutsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateLibraryWorkoutsRouteRoute
          })
const privateLibraryWorkoutsPlanIdRoute = privateLibraryWorkoutsPlanIdRouteImport.update({
            id: '/$planId',path: '/$planId',getParentRoute: () => privateLibraryWorkoutsRouteRoute
          })
const privateOfferArchiveIndexRoute = privateOfferArchiveIndexRouteImport.update({
            id: '/archive/',path: '/archive/',getParentRoute: () => privateOfferRouteRoute
          })
const privateOfferOrdersIndexRoute = privateOfferOrdersIndexRouteImport.update({
            id: '/orders/',path: '/orders/',getParentRoute: () => privateOfferRouteRoute
          })
const privateOfferPacksIndexRoute = privateOfferPacksIndexRouteImport.update({
            id: '/packs/',path: '/packs/',getParentRoute: () => privateOfferRouteRoute
          })
const privateOfferProductsIndexRoute = privateOfferProductsIndexRouteImport.update({
            id: '/products/',path: '/products/',getParentRoute: () => privateOfferRouteRoute
          })
const privateShopProductIdIndexRoute = privateShopProductIdIndexRouteImport.update({
            id: '/shop/$productId/',path: '/shop/$productId/',getParentRoute: () => privateRouteRoute
          })
const privateShopOrdersIndexRoute = privateShopOrdersIndexRouteImport.update({
            id: '/shop/orders/',path: '/shop/orders/',getParentRoute: () => privateRouteRoute
          })
const privateTraineesClientIdIndexRoute = privateTraineesClientIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateTraineesClientIdRouteRoute
          })
const privateTraineesClientIdBillingRoute = privateTraineesClientIdBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => privateTraineesClientIdRouteRoute
          })
const privateTraineesClientIdDietRoute = privateTraineesClientIdDietRouteImport.update({
            id: '/diet',path: '/diet',getParentRoute: () => privateTraineesClientIdRouteRoute
          })
const privateTraineesClientIdDietPlansRouteRoute = privateTraineesClientIdDietPlansRouteRouteImport.update({
            id: '/diet-plans',path: '/diet-plans',getParentRoute: () => privateTraineesClientIdRouteRoute
          })
const privateTraineesClientIdPacksRoute = privateTraineesClientIdPacksRouteImport.update({
            id: '/packs',path: '/packs',getParentRoute: () => privateTraineesClientIdRouteRoute
          })
const privateTraineesClientIdPlansRoute = privateTraineesClientIdPlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => privateTraineesClientIdRouteRoute
          })
const privateTraineesClientIdProgressRouteRoute = privateTraineesClientIdProgressRouteRouteImport.update({
            id: '/progress',path: '/progress',getParentRoute: () => privateTraineesClientIdRouteRoute
          })
const privateTraineesClientIdRecoveryRoute = privateTraineesClientIdRecoveryRouteImport.update({
            id: '/recovery',path: '/recovery',getParentRoute: () => privateTraineesClientIdRouteRoute
          })
const privateTraineesClientIdTrainingPlansRouteRoute = privateTraineesClientIdTrainingPlansRouteRouteImport.update({
            id: '/training-plans',path: '/training-plans',getParentRoute: () => privateTraineesClientIdRouteRoute
          })
const publicBlogSlugIndexRoute = publicBlogSlugIndexRouteImport.update({
            id: '/(public)/blog/$slug/',path: '/blog/$slug/',getParentRoute: () => rootRouteImport
          })
const publicBlogAuthorAuthorSlugRoute = publicBlogAuthorAuthorSlugRouteImport.update({
            id: '/(public)/blog/author/$authorSlug',path: '/blog/author/$authorSlug',getParentRoute: () => rootRouteImport
          })
const publicBlogCategoryCategorySlugRoute = publicBlogCategoryCategorySlugRouteImport.update({
            id: '/(public)/blog/category/$categorySlug',path: '/blog/category/$categorySlug',getParentRoute: () => rootRouteImport
          })
const privateOfferProductsProductIdIndexRoute = privateOfferProductsProductIdIndexRouteImport.update({
            id: '/products/$productId/',path: '/products/$productId/',getParentRoute: () => privateOfferRouteRoute
          })
const privateTraineesClientIdDietPlansIndexRoute = privateTraineesClientIdDietPlansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateTraineesClientIdDietPlansRouteRoute
          })
const privateTraineesClientIdDietPlansPlanIdRoute = privateTraineesClientIdDietPlansPlanIdRouteImport.update({
            id: '/$planId',path: '/$planId',getParentRoute: () => privateTraineesClientIdDietPlansRouteRoute
          })
const privateTraineesClientIdProgressIndexRoute = privateTraineesClientIdProgressIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateTraineesClientIdProgressRouteRoute
          })
const privateTraineesClientIdProgressMetricIdRoute = privateTraineesClientIdProgressMetricIdRouteImport.update({
            id: '/$metricId',path: '/$metricId',getParentRoute: () => privateTraineesClientIdProgressRouteRoute
          })
const privateTraineesClientIdTrainingPlansIndexRoute = privateTraineesClientIdTrainingPlansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateTraineesClientIdTrainingPlansRouteRoute
          })
const privateTraineesClientIdTrainingPlansPlanIdRoute = privateTraineesClientIdTrainingPlansPlanIdRouteImport.update({
            id: '/$planId',path: '/$planId',getParentRoute: () => privateTraineesClientIdTrainingPlansRouteRoute
          })





const privateBookingTrainingsRouteRouteChildren = {
  privateBookingTrainingsTrainingIdRoute: privateBookingTrainingsTrainingIdRoute,privateBookingTrainingsIndexRoute: privateBookingTrainingsIndexRoute
}

const privateBookingTrainingsRouteRouteWithChildren = privateBookingTrainingsRouteRoute._addFileChildren(privateBookingTrainingsRouteRouteChildren)



const privateBookingRouteRouteChildren = {
  privateBookingTrainingsRouteRoute: privateBookingTrainingsRouteRouteWithChildren,privateBookingIndexRoute: privateBookingIndexRoute,privateBookingAvailabilityIndexRoute: privateBookingAvailabilityIndexRoute,privateBookingEventsIndexRoute: privateBookingEventsIndexRoute,privateBookingGymIndexRoute: privateBookingGymIndexRoute,privateBookingRequestsIndexRoute: privateBookingRequestsIndexRoute,privateBookingSetupIndexRoute: privateBookingSetupIndexRoute
}

const privateBookingRouteRouteWithChildren = privateBookingRouteRoute._addFileChildren(privateBookingRouteRouteChildren)




const privateFinancesRouteRouteChildren = {
  privateFinancesIndexRoute: privateFinancesIndexRoute,privateFinancesInvoicesIndexRoute: privateFinancesInvoicesIndexRoute,privateFinancesOffersIndexRoute: privateFinancesOffersIndexRoute,privateFinancesPaymentsIndexRoute: privateFinancesPaymentsIndexRoute,privateFinancesSettingsIndexRoute: privateFinancesSettingsIndexRoute,privateFinancesSubscriptionsIndexRoute: privateFinancesSubscriptionsIndexRoute
}

const privateFinancesRouteRouteWithChildren = privateFinancesRouteRoute._addFileChildren(privateFinancesRouteRouteChildren)




const privateLibraryPlansRouteRouteChildren = {
  privateLibraryPlansPlanIdRoute: privateLibraryPlansPlanIdRoute,privateLibraryPlansIndexRoute: privateLibraryPlansIndexRoute
}

const privateLibraryPlansRouteRouteWithChildren = privateLibraryPlansRouteRoute._addFileChildren(privateLibraryPlansRouteRouteChildren)




const privateLibraryWorkoutsRouteRouteChildren = {
  privateLibraryWorkoutsPlanIdRoute: privateLibraryWorkoutsPlanIdRoute,privateLibraryWorkoutsIndexRoute: privateLibraryWorkoutsIndexRoute
}

const privateLibraryWorkoutsRouteRouteWithChildren = privateLibraryWorkoutsRouteRoute._addFileChildren(privateLibraryWorkoutsRouteRouteChildren)



const privateLibraryRouteRouteChildren = {
  privateLibraryPlansRouteRoute: privateLibraryPlansRouteRouteWithChildren,privateLibraryWorkoutsRouteRoute: privateLibraryWorkoutsRouteRouteWithChildren,privateLibraryExercisesRoute: privateLibraryExercisesRoute,privateLibraryIndexRoute: privateLibraryIndexRoute
}

const privateLibraryRouteRouteWithChildren = privateLibraryRouteRoute._addFileChildren(privateLibraryRouteRouteChildren)




const privateOfferRouteRouteChildren = {
  privateOfferIndexRoute: privateOfferIndexRoute,privateOfferArchiveIndexRoute: privateOfferArchiveIndexRoute,privateOfferOrdersIndexRoute: privateOfferOrdersIndexRoute,privateOfferPacksIndexRoute: privateOfferPacksIndexRoute,privateOfferProductsIndexRoute: privateOfferProductsIndexRoute,privateOfferProductsProductIdIndexRoute: privateOfferProductsProductIdIndexRoute
}

const privateOfferRouteRouteWithChildren = privateOfferRouteRoute._addFileChildren(privateOfferRouteRouteChildren)




const privateTraineesClientIdDietPlansRouteRouteChildren = {
  privateTraineesClientIdDietPlansPlanIdRoute: privateTraineesClientIdDietPlansPlanIdRoute,privateTraineesClientIdDietPlansIndexRoute: privateTraineesClientIdDietPlansIndexRoute
}

const privateTraineesClientIdDietPlansRouteRouteWithChildren = privateTraineesClientIdDietPlansRouteRoute._addFileChildren(privateTraineesClientIdDietPlansRouteRouteChildren)




const privateTraineesClientIdProgressRouteRouteChildren = {
  privateTraineesClientIdProgressMetricIdRoute: privateTraineesClientIdProgressMetricIdRoute,privateTraineesClientIdProgressIndexRoute: privateTraineesClientIdProgressIndexRoute
}

const privateTraineesClientIdProgressRouteRouteWithChildren = privateTraineesClientIdProgressRouteRoute._addFileChildren(privateTraineesClientIdProgressRouteRouteChildren)




const privateTraineesClientIdTrainingPlansRouteRouteChildren = {
  privateTraineesClientIdTrainingPlansPlanIdRoute: privateTraineesClientIdTrainingPlansPlanIdRoute,privateTraineesClientIdTrainingPlansIndexRoute: privateTraineesClientIdTrainingPlansIndexRoute
}

const privateTraineesClientIdTrainingPlansRouteRouteWithChildren = privateTraineesClientIdTrainingPlansRouteRoute._addFileChildren(privateTraineesClientIdTrainingPlansRouteRouteChildren)



const privateTraineesClientIdRouteRouteChildren = {
  privateTraineesClientIdDietPlansRouteRoute: privateTraineesClientIdDietPlansRouteRouteWithChildren,privateTraineesClientIdProgressRouteRoute: privateTraineesClientIdProgressRouteRouteWithChildren,privateTraineesClientIdTrainingPlansRouteRoute: privateTraineesClientIdTrainingPlansRouteRouteWithChildren,privateTraineesClientIdBillingRoute: privateTraineesClientIdBillingRoute,privateTraineesClientIdDietRoute: privateTraineesClientIdDietRoute,privateTraineesClientIdPacksRoute: privateTraineesClientIdPacksRoute,privateTraineesClientIdPlansRoute: privateTraineesClientIdPlansRoute,privateTraineesClientIdRecoveryRoute: privateTraineesClientIdRecoveryRoute,privateTraineesClientIdIndexRoute: privateTraineesClientIdIndexRoute
}

const privateTraineesClientIdRouteRouteWithChildren = privateTraineesClientIdRouteRoute._addFileChildren(privateTraineesClientIdRouteRouteChildren)



const privateTraineesRouteRouteChildren = {
  privateTraineesClientIdRouteRoute: privateTraineesClientIdRouteRouteWithChildren,privateTraineesIndexRoute: privateTraineesIndexRoute
}

const privateTraineesRouteRouteWithChildren = privateTraineesRouteRoute._addFileChildren(privateTraineesRouteRouteChildren)



const privateRouteRouteChildren = {
  privateBookingRouteRoute: privateBookingRouteRouteWithChildren,privateFinancesRouteRoute: privateFinancesRouteRouteWithChildren,privateLibraryRouteRoute: privateLibraryRouteRouteWithChildren,privateOfferRouteRoute: privateOfferRouteRouteWithChildren,privateTraineesRouteRoute: privateTraineesRouteRouteWithChildren,privateClientsSplatRoute: privateClientsSplatRoute,privateBillingIndexRoute: privateBillingIndexRoute,privateExercisesIndexRoute: privateExercisesIndexRoute,privateNotificationsIndexRoute: privateNotificationsIndexRoute,privatePaymentsIndexRoute: privatePaymentsIndexRoute,privateSettingsIndexRoute: privateSettingsIndexRoute,privateShopIndexRoute: privateShopIndexRoute,privateTodayIndexRoute: privateTodayIndexRoute,privateShopProductIdIndexRoute: privateShopProductIdIndexRoute,privateShopOrdersIndexRoute: privateShopOrdersIndexRoute
}

const privateRouteRouteWithChildren = privateRouteRoute._addFileChildren(privateRouteRouteChildren)




const OnboardingRouteRouteChildren = {
  OnboardingIndexRoute: OnboardingIndexRoute
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(OnboardingRouteRouteChildren)

const rootRouteChildren = {
  privateRouteRoute: privateRouteRouteWithChildren,OnboardingRouteRoute: OnboardingRouteRouteWithChildren,publicIndexRoute: publicIndexRoute,ConsentIndexRoute: ConsentIndexRoute,publicHelpSlugRoute: publicHelpSlugRoute,publicBlogIndexRoute: publicBlogIndexRoute,publicCallbackIndexRoute: publicCallbackIndexRoute,publicConsumerHealthDataIndexRoute: publicConsumerHealthDataIndexRoute,publicContactIndexRoute: publicContactIndexRoute,publicContentPolicyIndexRoute: publicContentPolicyIndexRoute,publicCookiesIndexRoute: publicCookiesIndexRoute,publicDpaIndexRoute: publicDpaIndexRoute,publicFeaturesIndexRoute: publicFeaturesIndexRoute,publicHelpIndexRoute: publicHelpIndexRoute,publicHowItWorksIndexRoute: publicHowItWorksIndexRoute,publicLegalIndexRoute: publicLegalIndexRoute,publicLoginIndexRoute: publicLoginIndexRoute,publicLogoutIndexRoute: publicLogoutIndexRoute,publicNewPasswordIndexRoute: publicNewPasswordIndexRoute,publicPricingIndexRoute: publicPricingIndexRoute,publicPrivacyIndexRoute: publicPrivacyIndexRoute,publicSignupIndexRoute: publicSignupIndexRoute,publicTermsIndexRoute: publicTermsIndexRoute,publicWhoItsForIndexRoute: publicWhoItsForIndexRoute,publicBlogAuthorAuthorSlugRoute: publicBlogAuthorAuthorSlugRoute,publicBlogCategoryCategorySlugRoute: publicBlogCategoryCategorySlugRoute,publicBlogSlugIndexRoute: publicBlogSlugIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)